export const FasMap = {
    "loading": {name: "fa-spinner wa-animation-spin"},
    "darr": {name: "fa-sort-down"},
    "uarr": {name: "fa-sort-up"},
    "rarr": {name: "fa-caret-right"},
    "add": {name: "fa-plus-circle", color: "green"},
    "sort": {name: "fa-bars"},
    "edit": {name: "fa-pencil-alt"},
    "marker": {name: "fa-map-marker-alt"},
    "settings": {name: "fa-cog", color: "MidnightBlue"},
    "design": {name: "fa-palette"},
    "script": {name: "fa-file-code"},
    "script-css": {name: "fab fa-css3-alt"},
    "delete": {name: "fa-minus-circle", color: "red"},
    "update": {name: "fa-redo-alt"},
    "map": {name: "fa-map"},
    "map-edit": {name: "fa-vector-square"},
    "rotate-left": {name: "fa-undo"},
    "ss excel": {name: "fa-file-excel"},
    "ss refunded": {name: "fa-times"},
    "color": {name: "fa-circle"},
    "yes": {name: "fa-regular fa-check", color: "green"},
    "no": {name: "fa-times", color: "red"},
    "palette": {name: "fa-palette", color: "orange"},
    "status-green": {name: "fa-circle", color: "green"},
    "status-red": {name: "fa-circle", color: "red"},
    "circle": {name: "fa-circle"},
    "script-lock": {name: "fa-lock"},
    "exclamation": {name: "fa-exclamation", color: "orange"},
    "download": {name: "fa-file-download", color: "blue"},
    "box": {name: "fa-box"},
    "search": {name: "fa-search"},
    "sync": {name: "fa-sync", color: "green"},
    "no-bw": {name: "fa-times"},
    "folders": {name: "fa-folder"},
    "comments": {name: "fa-comments"},
    "move": {name: "fa-long-arrow-alt-right"},
    "star": {name: "fa-star", color:"yellow"},
    "plus": {name: "fa-plus", color:"green"},
    "calendar": {name: "fa-calendar-day", color:"blue"},
    "info": {name: "fa-info", color:"black"},
    "notebooks": {name: "fa-copy", color:"light-gray"}
}